import React from 'react';
import { SkeletonRegistryCategory } from '../../SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../SkeletonRegistryItem';
import { Aspect_ } from '../../../../components/actor/Aspect_';
export class SkeletonRegistryLayout extends SkeletonRegistryCategory {
    label = 'Aspect wrap';
    constructor(parent) {
        super(parent);
        super.init();
    }
    wrapWithAspect = () => new SkeletonRegistryItem({
        isAspectWrapper: true,
        jsx: ({ at, aspect, aspectComponent }) => {
            if (!at.trait.local.valueOf.aspectName)
                return React.createElement("div", null, "Wrapping AspectName fehlt.");
            if (at.trait.local.valueOf.aspectName === aspect.name)
                return React.createElement("div", null, "Recursive Wrapping AspectName.");
            return (React.createElement(Aspect_, { aspect: aspect.actor.ownAspect[at.trait.local.valueOf.aspectName] }, aspectComponent));
        }
        /*  label: 'Wrap with Named Aspect',
        params: { core: ['aspectName'] } */
    });
    removeAspectWrap = () => new SkeletonRegistryItem({
        /*  label: 'Remove Aspect wrap', */
        isAspectWrapper: true,
        jsx: ({ aspectComponent }) => {
            return aspectComponent;
        }
    });
    customHtmlNode = () => new SkeletonRegistryItem({
        /*   label: 'HTML Child', */
        hidden: true,
        jsx: ({ at }) => {
            const Tag = at.trait.createdBy.trait.valueOf.jsxTag || 'div';
            return React.createElement(Tag, { dangerouslySetInnerHTML: { __html: at.trait.createdBy && at.trait.createdBy.trait.value } });
        }
    });
    questionCommentAspects = () => new SkeletonRegistryItem({
        jsx: ({ question }) => {
            if (question.questionComments.shouldShowCommentCorrect) {
                return React.createElement(Aspect_, { aspect: question.ownAspect.commentCorrect, key: "cc" });
            }
            if (question.questionComments.shouldShowCommentWrong) {
                return React.createElement(Aspect_, { aspect: question.ownAspect.commentWrong, key: "cw" });
            }
            if (question.questionComments.shouldShowComment) {
                return React.createElement(Aspect_, { aspect: question.ownAspect.comment, key: "c" });
            }
            return null;
        }
    });
}
